import { ReactElement } from 'react';
import { COMPETITION_SKELETON_DEFAULT_LENGTH } from 'utils/constants/app/magic-numbers-app';
import { createArray } from 'utils/helpers/create-fake-array';
import { ConditionalWrapper } from 'components/ConditionalWrapper';
import { EventCollapse } from 'components/EventCollapse';
import { MatchCardInlineSkeleton } from 'components/MatchCardInline/Skeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

type TProps = {
  count?: number;
  includeCollapse?: boolean;
  hideMargin?: boolean;
  className?: string;
};

export const SportRegionGameListSkeleton = ({
  count,
  includeCollapse,
  hideMargin,
  className
}: TProps): ReactElement => {
  const length = count ? count : COMPETITION_SKELETON_DEFAULT_LENGTH;

  return (
    <ConditionalWrapper
      condition={!!includeCollapse}
      wrapper={children => (
        <EventCollapse
          style={{ margin: hideMargin ? 0 : '4px' }}
          wrapperClassName={className}
          defaultActive
          key="collapse"
          title={
            <Skeleton
              title={{ style: { width: 100, margin: 0, height: 15 } }}
              paragraph={false}
              active
            />
          }
        >
          {children || <> </>}
        </EventCollapse>
      )}
    >
      <ConditionalWrapper
        condition={!!includeCollapse}
        wrapper={children => (
          <EventCollapse
            style={{ borderRadius: 0 }}
            headerClassName="sportsbook__sportRegionGameListSkeleton__header"
            wrapperClassName={className}
            defaultActive
            key="collapse"
            title={
              <Skeleton
                title={{ style: { width: 100, margin: 0, height: 15 } }}
                paragraph={false}
                active
              />
            }
          >
            {children || <> </>}
          </EventCollapse>
        )}
      >
        <div className="sportsbook__sportRegionGameListSkeleton__gameList">
          {createArray(length).map(key => (
            <MatchCardInlineSkeleton key={key} />
          ))}
        </div>
      </ConditionalWrapper>
    </ConditionalWrapper>
  );
};
